import { Fragment } from "react";

export const ParsedHintText = ({ text }: { text: string }) => {
  // Split by <br/> first to handle line breaks
  const segments = text.split(/<br\/?>/).map((segment, index, array) => {
    // Parse bold and italic tags
    const parts = segment.split(/(<[bi]>.*?<\/[bi]>)/);

    return (
      <Fragment key={index}>
        {parts.map((part, i) => {
          const trimmedPart = part.trim();
          if (part.startsWith("<b>")) {
            return (
              <span key={i} className="font-bold">
                {part.replace(/<\/?b>/g, "").trim()}
              </span>
            );
          } else if (part.startsWith("<i>")) {
            return (
              <span key={i} className="italic">
                {part.replace(/<\/?i>/g, "").trim()}
              </span>
            );
          }
          // Only render non-empty parts
          return trimmedPart ? <span key={i}>{trimmedPart}</span> : null;
        })}
        {index < array.length - 1 ? "\n" : null}
      </Fragment>
    );
  });

  return <p className="whitespace-pre-wrap">{segments}</p>;
};
